import { FC } from 'react';
import { Typography, useTheme} from "@material-ui/core";
import { Doughnut } from "react-chartjs-2";
import styled from "styled-components/macro";
const ChartWrapper = styled.div`
    position: relative;
`;
const DoughnutInner = styled.div`
    width: 100%;
    position: absolute;
    top: 50%;
    margin-top: -11px;
    text-align: center;
    z-index: 0;
`;
type PropsType = {
  data: Array<number | string>,
  labels: Array<string>
  height?: number;
  borderWidth?: number;
}
const DoughnutChart: FC<PropsType> = (
  {
    data,
    labels,
    height = 113,
    borderWidth = 0
  }) => {
  const theme = useTheme()
  const dataSum = data.reduce(
    (acc, num) => Number(acc) + Number(num), 0
  );

  const getColors = () => {
    const result: string[] = []
    let colorIndex = 0
    const colors = [
      theme.palette.secondary.main,
      '#818892',
      '#1565C0',
      '#E0E0E0'
    ]

    data.forEach((i) => {
      if (colorIndex === 3) colorIndex = 0
      result.push(colors[colorIndex])
      colorIndex++
    })
    return result
  }


  const chartOptions = {
    animation: {
      duration: 0
    },
    cutoutPercentage: 80,
    maintainAspectRatio: false,
    legend: {
      display: false,
      position: "right"
    },
    elements: {
      arc: {
        borderWidth: 0,
        weight: 0
      }
    }
  };

  const chartData = {
    maintainAspectRatio: false,
    responsive: true,
    labels: labels,
    datasets: [
      {
        data: data,
        //
        backgroundColor: getColors(),
        borderColor: theme.palette.background.paper,
        borderWidth: borderWidth
      }
    ]
  };
  return (
    <ChartWrapper style={{height: height + 'px'}}>
      <DoughnutInner>
        <Typography variant="h5">{dataSum}</Typography>
      </DoughnutInner>
      <Doughnut data={chartData} options={chartOptions} />
    </ChartWrapper>
  )
}
export default DoughnutChart